import data from "emoji-datasource";
import { flatten, groupBy, keyBy, map, mapValues, sortBy, values } from "lodash";
import { emptyImage } from "../constants/globals";
import punycode from "punycode";

export const emojiRegex = require("emoji-regex/text")();

export const emojis = data
  .filter((emoji) => emoji.has_img_apple && emoji.category !== "Skin Tones")
  .map((e1) => {
    e1.sheet_x *= -34;
    e1.sheet_y *= -34;
    mapValues(e1.skin_variations, (e2) => {
      e2?.sheet_x && (e2.sheet_x *= -34);
      e2?.sheet_y && (e2.sheet_y *= -34);
    });
    return e1;
  });
export const emojisByTones = flatten(map(emojis, (emoji) => values(emoji.skin_variations)));
export const emojisGroup = groupBy(sortBy(emojis, "sort_order"), "category");
export const emojisGroups = [
  { title: "Smileys & Emotion", icon: "😄" },
  { title: "People & Body", icon: "👋" },
  { title: "Animals & Nature", icon: "🐶" },
  { title: "Food & Drink", icon: "🍔" },
  { title: "Activities", icon: "⚽" },
  { title: "Travel & Places", icon: "🚌" },
  { title: "Objects", icon: "📷️" },
  { title: "Symbols", icon: "❤️" },
  { title: "Flags", icon: "🏁" },
];

export const emojisMap = {
  ...keyBy(emojis, "unified"),
  ...keyBy(emojis, "non_qualified"),
  ...keyBy(emojisByTones, "unified"),
  ...keyBy(emojisByTones, "non_qualified"),
};

export const nativeToUnified = (string: string) => {
  let cp, cps, hexes;
  cps = punycode.ucs2.decode(string);
  hexes = (function () {
    let _len4, _m, _results;
    _results = [];
    for (_m = 0, _len4 = cps.length; _m < _len4; _m++) {
      cp = cps[_m];
      _results.push(cp.toString(16));
    }
    return _results;
  })();
  return hexes.join("-").toUpperCase();
};

export const unifiedToNative = (string: string) => {
  let cp, cps;
  cps = (function () {
    let _i, _len, _ref, _results;
    _ref = string.split("-");
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      cp = _ref[_i];
      _results.push(parseInt(cp, 16));
    }
    return _results;
  })();
  return punycode.ucs2.encode(cps);
};

export const replaceToEmoji = (string: string) => {
  return string.replace(new RegExp(emojiRegex, "g"), (char) => {
    const emoji = emojisMap[nativeToUnified(char)];
    if (emoji === undefined) return char;
    /**
     * alt: native emoji for select and copy
     * src: transparent base64 image to prevent showing alt
     */
    return `<img alt="${char}" class="emoji_img" style="background-position-x: ${emoji.sheet_x}px; background-position-y: ${emoji.sheet_y}px" src="${emptyImage}" loading="lazy">`;
  });
};
